import { ZERO } from '@/constants/common';
import { useAppSelector } from '@/redux/hooks/useAppSelector';
import { loadingModelsSelector, modelsDataSelector } from '@/redux/models/models.selectors';
import { useContext, useState } from 'react';
import { CheckboxItem } from '@/components/Map/Drawer/ExportDrawer/CheckboxFilter/CheckboxFilter.types';
import { CheckboxFilter } from '../../CheckboxFilter';
import { CollapsibleSection } from '../../CollapsibleSection';
import { ExportContext } from '../ExportCompound.context';

type SubmapProps = {
  initialModelId?: number;
};

export const Submap = ({ initialModelId }: SubmapProps): React.ReactNode => {
  const { setModels, data } = useContext(ExportContext);
  const currentSelectedModels = data.models;
  const models = useAppSelector(modelsDataSelector);
  const loadingModels = useAppSelector(loadingModelsSelector);
  const isPending = loadingModels === 'pending';

  const mappedElementAnnotations = models.map(({ id, name }) => ({
    id: `${id}`,
    label: name,
  }));

  const options = useState<CheckboxItem[]>(mappedElementAnnotations);
  let scrollTop: number | undefined;
  if (
    !isPending &&
    currentSelectedModels.length === ZERO &&
    options.length > ZERO &&
    options[ZERO].length > ZERO
  ) {
    const initialModel =
      options[ZERO].filter(option => {
        return option.id === `${initialModelId}`;
      })[ZERO] || options[ZERO][ZERO];
    setModels([initialModel]);
    const o = mappedElementAnnotations.find(option => option.id === initialModel.id);
    if (o) {
      // eslint-disable-next-line no-magic-numbers
      scrollTop = 40 * mappedElementAnnotations.indexOf(o);
    }
  }

  return (
    <CollapsibleSection title="Diagram" dangerouslySetExpanded>
      {isPending && <p>Loading...</p>}
      {!isPending && mappedElementAnnotations && mappedElementAnnotations.length > ZERO && (
        <CheckboxFilter
          options={mappedElementAnnotations}
          currentOptions={currentSelectedModels}
          onCheckedChange={setModels}
          type="radio"
          scrollTop={scrollTop}
        />
      )}
    </CollapsibleSection>
  );
};
